export function getRotationFromTransform(transform: string): number {
  if (transform) {
    const matches = transform.match(/rotate[^(]*\([^\d]*(\d+\.?\d*).*\)/i);
    if (matches) {
      return parseFloat(matches[1]);
    }
  }
  return 0;
}
